<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменен состав заказа
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user"/>
    </div>
    <div class="os-history-item__content">
      <div class="menu-tem-log">
        <menu-edit-log-item
          v-for="(group, key) in item.group"
          :key="key"
          :log-item="group"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import MenuEditLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/MenuEditLogItem'

  export default {
    name: 'HistoryItemTypeMenu',
    components: { MenuEditLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      menuItemName () {
        return this.item?.menuItem?.name || 'блюдо удалено из системы'
      },
    },
    methods: {
      getMenuItem (logItem) {
        return this.item?.menuItem?.name || 'блюдо удалено из системы'
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";

.os-history-item {
  &__content {
    padding-bottom: 7px;
  }
}
.menu-tem-log {
  display: flex;
  flex-wrap: wrap;

}
</style>
